import React from 'react';
import style from './index.less';
var Loading = function (_a) {
    var _b = _a.isLoading, isLoading = _b === void 0 ? true : _b, children = _a.children;
    return isLoading ? (React.createElement("div", { style: { display: isLoading ? 'flex' : 'none' }, id: style.loading },
        React.createElement("div", null))) : children;
};
export default Loading;
